import { trace } from 'owa-trace';
// Polyfills are placed here to get imported before any bootstrapping code runs
//
// NOTE: NEVER add a polyfill that is not part of a spec implemented at least in all the modern browsers (Edge, Chrome, Firefox)

// raf/polyfill we need these polyfills because of Safari
if (!window.requestAnimationFrame) {
    trace.info('RAFAttempt');
    import('raf/polyfill').then(() => trace.info('RAFAdded'));
}

if (!('IntersectionObserver' in window)) {
    trace.info('IOAttempt');
    import('intersection-observer').then(() => trace.info('IOAdded'));
}

if (process.env.IS_OWA_DEV_ESBUILD) {
    // Reflect.hasOwnMetadata is used at runtime in decorators in esbuild
    //
    // Normally this isn't needed, and is handled by typescript
    // transpilation at compile-time.
    //
    // However, when running in esbuild, this isn't handled for us, so we require
    // this polyfill manually here.
    require('reflect-metadata');
}
